import { throttle } from 'throttle-debounce';
import { gsap } from 'gsap';

import сustomPageScroll from '../components/custom-scroll';

import {IS_TOUCH} from '../helpers/consts';

export const initHoverMedia = (blocks) => {
	if(IS_TOUCH) return;

	const imageContainer = document.querySelector('.js-hover-media-container');
	const hoverImage = document.querySelector('.js-hover-media-img');

	if(!imageContainer || !hoverImage) return;

	blocks.forEach((block) => {
		const image = block.getAttribute('data-hover-media-src');
		const img = new Image();
		img.src = image;
	});

	let mousePos = {x: 0, y: 0};
	let isHovering = false;

	blocks.forEach(function(block) {
		const image = block.getAttribute('data-hover-media-src');

		block.addEventListener('mouseenter', function(e) {
			mousePos.x = e.pageX;
			mousePos.y = e.pageY;

			isHovering = true;

			gsap.to(imageContainer, {
				duration: 0.2,
				scale: 0.9,
				autoAlpha: 0,
				onComplete: () => {
					if (isHovering) {
						hoverImage.src = image;
						gsap.to(imageContainer, {
							duration: 0.2,
							x: mousePos.x - window.innerWidth / 2,
							y: mousePos.y - window.innerHeight / 2,
							scale: 1,
							autoAlpha: 1,
						});
					}
				},
			});
		});

		block.addEventListener('mousemove', throttle(100, function(e) {
			mousePos.x = e.pageX;
			mousePos.y = e.pageY;

			gsap.to(imageContainer, {
				duration: 0.2,
				x: mousePos.x - window.innerWidth / 2,
				y: mousePos.y - window.innerHeight / 2,
			});
		}));

		block.addEventListener('mouseleave', function() {
			isHovering = false;
			gsap.to(imageContainer, {
				duration: 0.2,
				scale: 0.9,
				autoAlpha: 0,
			});
		});
	});


}
export default () => {
	const blocks = document.querySelectorAll('.js-hover-media-block');
	initHoverMedia(blocks);

	if(!IS_TOUCH) {
		setInterval(() => {
			const wrappers = document.querySelectorAll('.js-delegeted-hover-wrapper');
			wrappers.forEach((wrapper) => {
				const isInited = wrapper.classList.contains('is-inited');
				if(isInited) return;
				wrapper.classList.add('is-inited');
				
				const blocks = wrapper.querySelectorAll('.js-hover-media-block');
				initHoverMedia(blocks);
			});
		}, 500);
	}
}
